// import { IconSvgProps } from "../types";

export const RightLines = ({}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="192"
        height="109"
        viewBox="0 0 192 109"
        fill="none"
    >
        <path
            d="M9.5 0L195 0V19L9.5 19C4.2533 19 0 14.7467 0 9.5C0 4.25329 4.2533 0 9.5 0Z"
            fill="url(#paint0_linear_99_2557)"
        />
        <path
            d="M222.5 64L73.5 64C68.2533 64 64 59.7467 64 54.5C64 49.2533 68.2533 45 73.5 45L222.5 45C227.747 45 232 49.2533 232 54.5C232 59.7467 227.747 64 222.5 64Z"
            fill="url(#paint1_linear_99_2557)"
        />
        <path
            d="M20.5 90L268 90V109L20.5 109C15.2533 109 11 104.747 11 99.5C11 94.2533 15.2533 90 20.5 90Z"
            fill="url(#paint2_linear_99_2557)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_99_2557"
                x1="195"
                y1="9.5"
                x2="0"
                y2="9.5"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="white" stopOpacity="0.77" />
                <stop offset="0.519737" stopColor="white" stopOpacity="0.25" />
                <stop offset="1" stopColor="white" stopOpacity="0.73" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_99_2557"
                x1="64"
                y1="54.5"
                x2="232"
                y2="54.5"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#C9F2FF" stopOpacity="0.61" />
                <stop
                    offset="0.317708"
                    stopColor="#C9F2FF"
                    stopOpacity="0.54"
                />
                <stop
                    offset="0.640625"
                    stopColor="#C9F2FF"
                    stopOpacity="0.16"
                />
                <stop offset="1" stopColor="#C9F2FF" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_99_2557"
                x1="268"
                y1="99.5"
                x2="11"
                y2="99.5"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#EAE6FF" stopOpacity="0" />
                <stop
                    offset="0.333184"
                    stopColor="#F1F3FF"
                    stopOpacity="0.290176"
                />
                <stop
                    offset="0.645833"
                    stopColor="#EFEFFF"
                    stopOpacity="0.505208"
                />
                <stop offset="1" stopColor="#EAE6FF" />
            </linearGradient>
        </defs>
    </svg>
);
